<div class="event-details-page" *ngIf="blmEvents">
    <!-- Hero Section -->
    <header class="hero-section">
        <div class="hero-background"
            [style.background-image]="'url(' + blmEvents.fields.images?.[0]?.fields?.file?.url + ')'"></div>
        <div class="hero-overlay"></div>
        <div class="hero-content">
            <h1 class="event-title" [innerText]="blmEvents.fields.title"></h1>
            <div class="hero-meta" *ngIf="blmEvents.fields.date">
                <mat-icon>calendar_today</mat-icon>
                <ng-container *ngIf="blmEvents.fields.dateTime; else detailDateOnly">
                    <span>{{ blmEvents.fields.dateTime | date:'MMM d, y, h:mm a' }}</span>
                </ng-container>
                <ng-template #detailDateOnly>
                    <span>{{ blmEvents.fields.date }}</span>
                </ng-template>
            </div>
        </div>
        <div class="scroll-indicator">
            <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
    </header>

    <!-- Main Content Layout -->
    <main class="content-container">
        <div class="content-grid">
            <!-- Article Content -->
            <article class="event-article">
                <div class="text-content">
                    <p class="drop-cap-text" [innerHTML]="blmEvents.fields.longDescription | mdToHtml"></p>
                </div>
            </article>

            <!-- Sidebar -->
            <aside class="event-sidebar">
                <div class="sidebar-wrapper">
                    <div class="visual-card" *ngIf="blmEvents.fields.images?.[0]?.fields?.file?.url">
                        <img class="featured-image" [src]="blmEvents.fields.images[0].fields.file.url"
                            [alt]="blmEvents.fields.images[0].fields.file.title || blmEvents.fields.title">
                    </div>

                    <div class="action-card">
                        <h3>Event Actions</h3>
                        <div class="action-buttons">
                            <button mat-flat-button class="primary-btn"
                                [routerLink]="['/gallery', blmEvents.fields.url]">
                                <mat-icon>collections</mat-icon>
                                View Gallery
                            </button>
                            <button mat-stroked-button class="secondary-btn" routerLink="/events">
                                <mat-icon>arrow_back</mat-icon>
                                Back to Events
                            </button>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
    </main>
</div>